(() => {
  const SELECTOR = '[data-ynz-global-header]';

  const isEnglish = () => document.documentElement.lang.toLowerCase().startsWith('en');
  const label = (es, en) => (isEnglish() ? en : es);

  const installCourseStyles = () => {
    if (document.getElementById('ynzh-course-cta-styles')) return;

    const style = document.createElement('style');
    style.id = 'ynzh-course-cta-styles';
    style.textContent = `
      .ynzh-course-cta {
        --ynzh-course-blue:#1950D1;
        --ynzh-course-orange:#E05E12;
        width:92px;
        height:40px;
        flex:0 0 92px;
        position:relative;
        display:inline-grid;
        place-items:center;
        isolation:isolate;
        border-radius:14px;
        color:#F5F5F7 !important;
        font-family:var(--ynzh-font,"Inter",sans-serif);
        font-size:11px;
        font-weight:650;
        line-height:1;
        letter-spacing:0;
        -webkit-tap-highlight-color:transparent;
        transform:translateZ(0);
      }

      .ynzh-course-cta::before {
        content:"";
        position:absolute;
        inset:-20px -27px;
        z-index:-4;
        pointer-events:none;
        border-radius:30px;
        background:
          radial-gradient(circle at 29% 52%,color-mix(in srgb,var(--ynzh-course-orange) 72%,transparent),transparent 36%),
          radial-gradient(circle at 73% 49%,color-mix(in srgb,var(--ynzh-course-blue) 78%,transparent),transparent 38%),
          radial-gradient(circle,rgba(255,255,255,.13) 0 1px,transparent 1.15px);
        background-size:auto,auto,3px 3px;
        opacity:.82;
        filter:blur(.15px) saturate(1.10);
        -webkit-mask-image:radial-gradient(ellipse at center,#000 0 36%,rgba(0,0,0,.84) 56%,transparent 80%);
        mask-image:radial-gradient(ellipse at center,#000 0 36%,rgba(0,0,0,.84) 56%,transparent 80%);
        animation:ynzh-course-aura 5.2s ease-in-out infinite;
        animation-delay:-1.6s;
        will-change:transform,opacity;
      }

      .ynzh-course-cta__glow {
        position:absolute;
        pointer-events:none;
        overflow:hidden;
        border-radius:16px;
      }

      .ynzh-course-cta__glow::before {
        content:"";
        position:absolute;
        inset:-155%;
        background:linear-gradient(90deg,#E05E12 14%,#F2A06D 27%,transparent 45% 55%,#86A8F8 73%,#1950D1 86%);
        transform:rotate(10deg) scale(1);
        transform-origin:center;
      }

      .ynzh-course-cta__glow--outer {
        inset:-9px;
        z-index:-3;
        opacity:.72;
        filter:blur(14px);
      }

      .ynzh-course-cta__glow--middle {
        inset:-1.5px;
        z-index:-2;
        opacity:.92;
        filter:blur(2.5px);
      }

      .ynzh-course-cta__border {
        position:absolute;
        inset:0;
        z-index:-1;
        padding:1px;
        overflow:hidden;
        border-radius:14px;
        background:rgba(255,255,255,.10);
      }

      .ynzh-course-cta__border::before {
        content:"";
        position:absolute;
        inset:-115%;
        background:linear-gradient(90deg,rgba(224,94,18,.86) 16%,rgba(246,192,158,.82) 30%,transparent 46% 54%,rgba(151,180,255,.88) 70%,rgba(25,80,209,.96) 84%);
        opacity:.98;
        transform:rotate(10deg);
        transform-origin:center;
      }

      .ynzh-course-cta__surface {
        width:calc(100% - 2px);
        height:calc(100% - 2px);
        position:relative;
        z-index:2;
        display:grid;
        place-items:center;
        overflow:hidden;
        border-radius:13px;
        background:linear-gradient(180deg,rgba(255,255,255,.045),transparent 42%),#111215;
        box-shadow:inset 0 1px 0 rgba(255,255,255,.075),inset 0 -12px 22px rgba(0,0,0,.18),0 8px 22px rgba(0,0,0,.17);
        transition:transform 260ms cubic-bezier(.23,1,.32,1),background 260ms ease,box-shadow 260ms ease;
      }

      .ynzh-course-cta__surface::before {
        content:"";
        position:absolute;
        inset:0;
        pointer-events:none;
        background:
          radial-gradient(circle at 22% 10%,rgba(255,255,255,.10),transparent 25%),
          linear-gradient(105deg,rgba(224,94,18,.075),transparent 38%,rgba(25,80,209,.10));
        background-size:145% 145%,155% 155%;
        opacity:.92;
        animation:ynzh-course-sheen 8.5s ease-in-out infinite;
      }

      .ynzh-course-cta__label { position:relative; z-index:2; }

      .ynzh-course-cta[aria-current="page"] .ynzh-course-cta__surface {
        background:linear-gradient(180deg,rgba(255,255,255,.065),transparent 42%),#15161A;
      }

      @keyframes ynzh-course-aura {
        0%,100% { opacity:.74; transform:scale(.99); }
        50% { opacity:.90; transform:scale(1.045); }
      }

      @keyframes ynzh-course-idle {
        0% { transform:rotate(10deg) scale(1); }
        50% { transform:rotate(190deg) scale(.94); }
        100% { transform:rotate(370deg) scale(1); }
      }

      @keyframes ynzh-course-spin {
        0% { transform:rotate(10deg) scale(1); }
        50% { transform:rotate(190deg) scale(.89); }
        100% { transform:rotate(370deg) scale(1); }
      }

      @keyframes ynzh-course-sheen {
        0%,100% { background-position:10% 50%,25% 50%; opacity:.78; }
        50% { background-position:90% 50%,75% 50%; opacity:.96; }
      }

      .ynzh-course-cta__glow::before,
      .ynzh-course-cta__border::before {
        animation:ynzh-course-idle 7.8s linear infinite;
        animation-delay:-2.4s;
        will-change:transform;
      }

      @media (hover:hover) and (pointer:fine) {
        .ynzh-course-cta:hover::before {
          animation-duration:3.8s;
          filter:blur(.15px) saturate(1.14);
        }
        .ynzh-course-cta:hover .ynzh-course-cta__glow--outer { opacity:.86; }
        .ynzh-course-cta:hover .ynzh-course-cta__glow--middle { opacity:1; }
        .ynzh-course-cta:hover .ynzh-course-cta__glow::before,
        .ynzh-course-cta:hover .ynzh-course-cta__border::before {
          animation:ynzh-course-spin 5.2s cubic-bezier(.56,.15,.28,.86) infinite;
        }
        .ynzh-course-cta:hover .ynzh-course-cta__surface {
          transform:translateY(-1px);
          box-shadow:inset 0 1px 0 rgba(255,255,255,.09),inset 0 -12px 22px rgba(0,0,0,.16),0 10px 28px rgba(0,0,0,.22);
        }
      }

      .ynzh-course-cta:active .ynzh-course-cta__surface { transform:scale(.975); }

      @media (max-width:640px) {
        .ynz10-about { gap:36px; }
        .ynzh-course-cta { width:72px; height:36px; flex-basis:72px; border-radius:13px; font-size:10px; }
        .ynzh-course-cta__surface { border-radius:12px; }
        .ynzh-course-cta__border { border-radius:13px; }
        .ynzh-course-cta::before { inset:-14px -18px; opacity:.78; }
        .ynzh-course-cta__glow--outer { opacity:.68; }
        .ynzh-course-cta__glow--middle { opacity:.90; }
        .ynzh-course-cta__glow::before,
        .ynzh-course-cta__border::before { animation-duration:6.4s; }
      }

      @media (prefers-reduced-motion:reduce) {
        .ynzh-course-cta::before,
        .ynzh-course-cta__glow::before,
        .ynzh-course-cta__border::before,
        .ynzh-course-cta__surface::before { animation:none !important; }
      }
    `;

    document.head.appendChild(style);
  };

  const installCourseCTA = (root) => {
    const actions = root.querySelector('.ynzh-actions');
    if (!actions || actions.querySelector('.ynzh-course-cta')) return;

    installCourseStyles();

    const routeRoot = window.Shopify?.routes?.root || '/';
    const localizedRoot = routeRoot.replace(/\/?$/, '/');
    const courseLabel = label('Cursos', 'Courses');
    const link = document.createElement('a');

    link.className = 'ynzh-course-cta';
    link.href = `${localizedRoot}pages/cursos`;
    link.setAttribute('aria-label', courseLabel);

    if (window.location.pathname.replace(/\/+$/, '').endsWith('/pages/cursos')) {
      link.setAttribute('aria-current', 'page');
    }

    link.innerHTML = `
      <span class="ynzh-course-cta__glow ynzh-course-cta__glow--outer" aria-hidden="true"></span>
      <span class="ynzh-course-cta__glow ynzh-course-cta__glow--middle" aria-hidden="true"></span>
      <span class="ynzh-course-cta__border" aria-hidden="true"></span>
      <span class="ynzh-course-cta__surface"><span class="ynzh-course-cta__label">${courseLabel}</span></span>
    `;

    actions.prepend(link);
  };

  const initHeader = (root) => {
    if (!root || root.dataset.ynzhInitialized === 'true') return;
    root.dataset.ynzhInitialized = 'true';

    const header = root.querySelector('[data-ynzh-header]');
    const nav = root.querySelector('[data-ynzh-nav]');
    const toggle = root.querySelector('[data-ynzh-menu-toggle]');
    const authPortal = root.querySelector('[data-ynzh-auth-portal]');
    const authDialog = root.querySelector('[data-ynzh-auth-dialog]');
    const authOpen = root.querySelector('[data-ynzh-auth-open]');
    const authForm = root.querySelector('[data-ynzh-auth-form]');
    const authEmail = root.querySelector('[data-ynzh-auth-email]');
    const authToast = root.querySelector('[data-ynzh-auth-toast]');
    const authCloseButtons = root.querySelectorAll('[data-ynzh-auth-close]');

    let scrollFrame = null;
    let authReturnFocus = null;
    let authToastTimer = null;

    const normalizeNavLinks = () => {
      if (!nav) return;

      const routeRoot = window.Shopify?.routes?.root || '/';
      const localizedRoot = routeRoot.replace(/\/?$/, '/');
      const shopUrl = `${localizedRoot}pages/productos`;
      const contactUrl = `${localizedRoot}pages/contact`;

      nav.querySelectorAll('a[href]').forEach((link) => {
        try {
          const url = new URL(link.href, window.location.origin);
          const normalizedPath = url.pathname.replace(/\/+$/, '');
          const malformedLocalizedShop = /^\/[a-z]{2}(?:-[a-z]{2})?pages\/productos$/i.test(normalizedPath);

          if (normalizedPath === '/pages/productos' || normalizedPath.endsWith('/pages/productos') || malformedLocalizedShop) {
            link.href = shopUrl;
            return;
          }

          if (normalizedPath.endsWith('/pages/servicios')) link.href = contactUrl;
        } catch (_error) {
          // Preserve Shopify's original URL if parsing fails.
        }
      });
    };

    const hideAuthToast = () => {
      if (authToastTimer !== null) window.clearTimeout(authToastTimer);
      authToastTimer = null;
      authToast?.classList.remove('is-visible');
    };

    const showAuthToast = () => {
      if (!authToast) return;
      hideAuthToast();
      authToast.classList.add('is-visible');
      authToastTimer = window.setTimeout(hideAuthToast, 3200);
    };

    const closeMenu = ({ returnFocus = false } = {}) => {
      if (!nav || !toggle) return;
      nav.classList.remove('is-open');
      toggle.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
      toggle.setAttribute('aria-label', toggle.dataset.openLabel || label('Abrir menú', 'Open menu'));
      if (returnFocus) toggle.focus();
    };

    const authFocusable = () => {
      if (!authDialog) return [];
      return [...authDialog.querySelectorAll('a[href],button:not([disabled]),input:not([disabled]),[tabindex]:not([tabindex="-1"])')]
        .filter((element) => element.offsetParent !== null);
    };

    const openAuth = () => {
      if (!authPortal) return;
      closeMenu();
      authReturnFocus = document.activeElement;
      authPortal.removeAttribute('inert');
      authPortal.classList.add('is-open');
      authPortal.setAttribute('aria-hidden', 'false');
      document.body.classList.add('ynzh-auth-open');
      hideAuthToast();
      window.requestAnimationFrame(() => authEmail?.focus());
    };

    const closeAuth = ({ returnFocus = true } = {}) => {
      if (!authPortal?.classList.contains('is-open')) return;
      authPortal.classList.remove('is-open');
      authPortal.setAttribute('aria-hidden', 'true');
      authPortal.setAttribute('inert', '');
      document.body.classList.remove('ynzh-auth-open');
      hideAuthToast();
      authEmail?.removeAttribute('aria-invalid');
      if (returnFocus && authReturnFocus instanceof HTMLElement) authReturnFocus.focus();
    };

    const syncHeader = () => {
      scrollFrame = null;
      header?.classList.toggle('is-scrolled', window.scrollY > 12);
    };

    const requestHeaderSync = () => {
      if (scrollFrame !== null) return;
      scrollFrame = window.requestAnimationFrame(syncHeader);
    };

    normalizeNavLinks();
    installCourseCTA(root);
    syncHeader();

    window.addEventListener('scroll', requestHeaderSync, { passive: true });

    toggle?.addEventListener('click', () => {
      if (!nav) return;
      const open = !nav.classList.contains('is-open');
      nav.classList.toggle('is-open', open);
      toggle.classList.toggle('is-open', open);
      toggle.setAttribute('aria-expanded', String(open));
      toggle.setAttribute('aria-label', open
        ? toggle.dataset.closeLabel || label('Cerrar menú', 'Close menu')
        : toggle.dataset.openLabel || label('Abrir menú', 'Open menu'));
    });

    authOpen?.addEventListener('click', openAuth);
    authCloseButtons.forEach((button) => button.addEventListener('click', () => closeAuth()));

    authForm?.addEventListener('submit', (event) => {
      event.preventDefault();

      if (!authEmail?.value.trim() || !authEmail.checkValidity()) {
        authEmail?.setAttribute('aria-invalid', 'true');
        showAuthToast();
        authEmail?.focus();
        return;
      }

      hideAuthToast();
      authEmail.removeAttribute('aria-invalid');
      const destination = new URL(authForm.action, window.location.origin);
      destination.searchParams.set('login_hint', authEmail.value.trim());
      window.location.assign(destination.href);
    });

    authEmail?.addEventListener('input', () => {
      if (!authEmail.value.trim() || !authEmail.checkValidity()) return;
      authEmail.removeAttribute('aria-invalid');
      hideAuthToast();
    });

    nav?.querySelectorAll('a').forEach((link) => link.addEventListener('click', () => closeMenu()));

    document.addEventListener('pointerdown', (event) => {
      if (!nav?.classList.contains('is-open') || root.contains(event.target)) return;
      closeMenu();
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && authPortal?.classList.contains('is-open')) {
        closeAuth();
        return;
      }

      if (event.key === 'Escape' && nav?.classList.contains('is-open')) {
        closeMenu({ returnFocus: true });
      }

      if (event.key !== 'Tab' || !authPortal?.classList.contains('is-open')) return;

      const focusable = authFocusable();
      if (!focusable.length) {
        event.preventDefault();
        authDialog?.focus();
        return;
      }

      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth > 1180) closeMenu();
    }, { passive: true });
  };

  const initAll = (scope = document) => scope.querySelectorAll(SELECTOR).forEach(initHeader);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => initAll(event.target));
})();